import OrganizationCard from "./OrganizationCard";
import { NavLink } from "react-router-dom";
import secoursPopulaire from "../images/secours-populaire.jpg";
import croixRouge from "../images/croix-rouge.jpg";
import fondationDeFrance from "../images/fondation-de-france.jpg";
import accdOm from "../images/accdom.png";
import protectionCivile from "../images/DGSCGC.jpg";
import humanAppealFrance from "../images/human-appeal.jpg";
import fondationDeLille from "../images/fondation-de-lille.jpg";

function DonationCalls() {
  const organizations = [
    {
      name: "Soutien Solidaire Mayotte à Toulouse",
      objective:
        "L'objectif est de faire des achats de denrées alimentaires ainsi que des produits de première nécessité mais aussi de prendre en charge le transport vers Mayotte.",
      verificationDate: "27/12/2024",
      link: "https://tribee.fr/participations/collectif-mahorais-de-toulouse",
    },
    {
      name: "Collecte de fonds pour les enfants de Koungou (Cloturée, 11 000€ récoltés)",
      objective:
        "Les enseignants d'EPS du collège de Koungou organisent une collecte de fonds pour financer l'envoi d'un container rempli de vêtements/chaussures pour les enfants de la commune de Koungou.",
      verificationDate: "27/12/2024",
      source:
        "https://www.facebook.com/share/p/BuTJZshEQwFoz7Bq/?mibextid=wwXIfr",
      link: "https://www.leetchi.com/fr/c/collecte-de-fonds-pour-les-enfants-de-koungou-8901367",
    },
    {
      name: "Souboutou Ouhédzé Jilaho",
      objective:
        "Association contre les violences sexuelles et sexistes, plus que jamais en aide sur le terrain et en lien avec l'hexagone",
      verificationDate: "27/12/2024",
    },
    {
      name: "SECOURS POPULAIRE",
      objective:
        "Appel urgent aux dons financiers pour venir en aide aux populations touchées par le cyclone Chido à Mayotte et aux Comores.",
      verificationDate: "17/12/2024",
      imageUrl: secoursPopulaire,
      link: "https://don.secourspopulaire.fr/mayotte/~mon-don",
    },
    {
      name: "CROIX ROUGE",
      objective:
        "La Croix-Rouge, via son antenne située à La Réunion, va bientôt envoyer des kits d'urgence à Mayotte. La priorité, dans l'immédiat, est d'apporter de l'eau, de la...",
      verificationDate: "18/12/2024",
      imageUrl: croixRouge,
      link: "https://www.croix-rouge.fr/urgence-mayotte-cyclone-chido/cyclone-chido-la-croix-rouge-francaise-presente-a-mayotte-et-a-la-reunion",
    },
    {
      name: "FONDATION DE FRANCE",
      objective:
        "Déployer rapidement des actions de première nécessité et venir en aide aux victimes (mise à l'abri, soutien psychologique, ...)",
      verificationDate: "17/12/2024",
      imageUrl: fondationDeFrance,
      link: "https://dons.fondationdefrance.org/solidarite-mayotte/~mon-don",
    },
    {
      name: "ACCD'OM",
      objective:
        "Les fonds seront redistribués INTÉGRALEMENT à la population mahoraise. Répartition par communes selon le nombre d'habitant (source INSEE) de la totalité de la somme...",
      verificationDate: "18/12/2024",
      imageUrl: accdOm,
      link: "https://www.helloasso.com/associations/association-des-communes-et-collectivites-d-outre-mer/collectes/soutien-a-mayotte",
    },
    {
      name: "PROTECTION CIVILE",
      objective:
        "S'activent pour apporter leur soutien aux populations affectées : soutien d'urgence, distribution de matériel essentiel, déblaiement des maisons et accompagnement des...",
      verificationDate: "17/12/2024",
      imageUrl: protectionCivile,
      link: "https://don.protection-civile.org/cyclone-chido",
    },
    {
      name: "HUMAN APPEAL FRANCE",
      objective:
        "Appel urgent aux dons financiers pour venir en aide aux populations touchées par le cyclone Chido à Mayotte et aux Comores.",
      verificationDate: "18/12/2024",
      imageUrl: humanAppealFrance,
      link: "https://humanappeal.fr/faire-un-don/projets/urgences/don-mayotte",
    },
    {
      name: "FONDATION DE LILLE",
      objective:
        "Appel urgent aux dons financiers pour venir en aide aux populations touchées par le cyclone Chido à Mayotte et aux Comores.",
      verificationDate: "18/12/2024",
      imageUrl: fondationDeLille,
      link: "https://www.helloasso.com/associations/fondation-de-lille/formulaires/49",
    },
  ];

  return (
    <div className="donations-grid">
      {organizations.map((org, index) => (
        <OrganizationCard
          key={index}
          organization={org.name}
          objective={org.objective}
          verificationDate={org.verificationDate}
          source={org.source}
          imageUrl={org.imageUrl}
          link={org.link}
        />
      ))}
    </div>
  );
}

export default DonationCalls;
